import { action } from 'typesafe-actions';
import { VALIDATION_WARNING, WarningState } from './type';

export const setValidationWarning = (issueState: WarningState) => {
    return action(VALIDATION_WARNING, issueState);
};
